import { render, staticRenderFns } from "./PainelConfiguracaoUsuarioForm.vue?vue&type=template&id=ee2f6f72"
import script from "./PainelConfiguracaoUsuarioForm.vue?vue&type=script&lang=js"
export * from "./PainelConfiguracaoUsuarioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports